import v from './Variables';

function fontColors() {
  let styles = '';

  Object.keys(v.colors).forEach((key) => {
    styles += `
       .font--${key} {

         color: ${(v.colors as any)[key]} !important;
       }
     `;
  });

  return styles;
}

export default fontColors;
